import { menuItems, menuCategories } from '../data/menuData';

const categoryLabels = Object.fromEntries(
  menuCategories
    .filter((cat) => cat.id !== 'all')
    .map((cat) => [cat.id, cat.label.replace(/^[^\s]+\s/, '')])
);

function normalize(text) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function itemHaystack(item) {
  return normalize(
    [
      item.name,
      item.desc,
      categoryLabels[item.category] || item.category,
      ...item.includedIngredients.map((ing) => ing.name),
      ...(item.contents || []),
      ...(item.extraIngredients || []).map((ing) => ing.name),
    ].join(' ')
  );
}

export function searchMenuItems(query, { limit = 8, category } = {}) {
  const terms = normalize(query.trim()).split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [];

  let pool = menuItems;
  if (category && category !== 'all') {
    pool = pool.filter((item) => item.category === category);
  }

  return pool
    .filter((item) => {
      const haystack = itemHaystack(item);
      return terms.every((term) => haystack.includes(term));
    })
    .slice(0, limit);
}

export function getCategoryLabel(categoryId) {
  return categoryLabels[categoryId] || categoryId;
}
